<template>
	<b-form-group :label="value.label" class="text-left">
		<b-form-checkbox
			v-model="value.value"
			name="check-button"
			switch
			class="mt-2"
		/>
	</b-form-group>
</template>

<script>
export default {
	props: ['value'],
};
</script>
